var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-item"},_vm._l((_vm.filterList),function(filterItem,index){return _c('span',{key:'filter_' + index},[_c('FilterItem',{attrs:{"filter-item":filterItem,"selected-items":_vm.selectedItems}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }